import { Button, CircularProgress } from '@mui/material';
import Toast from 'components/toasts/Toast';
import FormattedMessage from 'features/i18n/FormattedMessage';
import { encodeSocialLoginState } from 'features/social/encodeSocialLoginState';
import { getErrorCodeFromAxiosError } from 'features/teamInvitation/getErrorCodeFromAxiosError';
import { InvitationPageWrapper } from 'features/workspaces/invitations/InvitationPageWrapper';
import { useWorkspaceInvitationSearchParams } from 'features/workspaces/invitations/useWorkspaceInvitationSearchParams';
import { useWorkspaceInviteAcceptMutation } from 'features/workspaces/invitations/useWorkspaceInviteAcceptMutation';
import { getWorkspaceId } from 'features/workspaces/workspaceSlice';
import { JwtLoginSnippet } from 'pages/login/LoginPage';
import { useNavigate } from 'react-router-dom';
import { handleCommonApiError } from 'services/api/utils/handleCommonApiError';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export const WorkspaceInvitationExistingCustomerLandingPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userEmail = useAppSelector(state => state.customer.email);

  const { inviteId, workspaceId, confirmationCode } = useWorkspaceInvitationSearchParams();

  const { mutateAsync: acceptInvite, isPending } = useWorkspaceInviteAcceptMutation();

  const onSubmit = () =>
    acceptInvite(
      { inviteId, workspaceId, confirmationCode },
      {
        onSuccess: () => {
          dispatch(getWorkspaceId.request());
          navigate('/');
        },
        onError: (error: unknown) => {
          const errorCode = getErrorCodeFromAxiosError(error);
          if (errorCode) {
            Toast.backendError(handleCommonApiError(errorCode));
            return;
          }

          Toast.commonError();
        },
      }
    );

  if (!userEmail) {
    const state = encodeSocialLoginState({
      campaignUrl: location.pathname + location.search,
    });

    return <JwtLoginSnippet state={state} prompt="create" />;
  }

  return (
    <InvitationPageWrapper>
      <Button
        variant="contained"
        color="primary"
        id="next-button"
        disabled={isPending}
        startIcon={isPending ? <CircularProgress size={16} /> : undefined}
        type="submit"
        fullWidth={true}
        onClick={onSubmit}
      >
        <FormattedMessage id="team.invite.accept_invitation" />
      </Button>
    </InvitationPageWrapper>
  );
};
